var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ3TeleruptorStopForcing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 67h20v4H49v-4zm2.56-48.7a9.22 9.22 0 0118.44 0c0 3.65-2.5 6.8-5.1 8.77v7.65l-2.79 2.51 2.78 3.17-2.78 2.7 2.74 3.36L61 50.92l-3.91-4.46V26.73a9.21 9.21 0 01-5.53-8.43zM58 14.58a2.22 2.22 0 102.22-2.22A2.21 2.21 0 0058 14.58zM36 52v7H26v4h24v-4H40v-7h-4zM6.75 28a21 21 0 1142.001 0A21 21 0 016.75 28zm4 0a17 17 0 1034 0 17 17 0 00-34 0zM30 16h-4v24h4V16zM7 71h20v-4H7v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J3_Teleruptor_stop_forcing.072f4ecc.svg";
export { SvgJ3TeleruptorStopForcing as ReactComponent };